import styled from 'styled-components';
import { COLORS } from '../../constants/colors';

export const SidebarContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: ${props => props.isCollapsed ? '64px' : '280px'};
  background: #fff;
  border-right: 1px solid #e8e8e8;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 280px;
    transform: ${props => props.isMobileOpen ? 'translateX(0)' : 'translateX(-100%)'};
    transition: transform 0.3s ease;
    box-shadow: ${props => props.isMobileOpen ? '2px 0 8px rgba(0, 0, 0, 0.1)' : 'none'};
  }
`;

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #e8e8e8;
  min-height: 60px;
  height: 60px;
`;

export const LogoSection = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  color: ${COLORS.$mainBlue};
  
  ${props => props.isCollapsed && `
    justify-content: center;
  `}
`;

export const UserSection = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
`;

export const UserAvatar = styled.div`
  margin-right: 12px;
`;

export const UserInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const NavSection = styled.div`
  flex: 1;
  padding: 8px 0;
  overflow-y: auto;
`;

export const NavItem = styled.div`
  display: flex;
  align-items: center;
  padding: ${props => props.isChild ? '8px 16px 8px 48px' : '12px 16px'};
  margin: ${props => props.isChild ? '2px 8px' : '4px 8px'};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: ${props => props.isActive ? COLORS.$mainBlue : '#333'};
  background-color: ${props => props.isActive ? `${COLORS.$mainBlue}15` : 'transparent'};
  font-weight: ${props => props.isActive ? '600' : '400'};
  position: relative;
  
  &:hover {
    background-color: ${props => props.isActive ? `${COLORS.$mainBlue}20` : '#f5f5f5'};
    color: ${props => props.isActive ? COLORS.$mainBlue : '#000'};
  }

  ${props => props.hasChildren && `
    &:hover {
      background-color: #f5f5f5;
    }
  `}

  ${props => props.isChild && `
    font-size: 14px;
    border-left: 2px solid ${props.isActive ? COLORS.$mainBlue : 'transparent'};
    margin-left: 16px;
    padding-left: 32px;
  `}

  ${props => props.isCollapsed && !props.isChild && `
    justify-content: center;
    padding: 12px 8px;
    margin: 4px 8px;
  `}
`;

export const NavIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${props => props.isCollapsed ? '0' : '12px'};
  font-size: ${props => props.isChild ? '14px' : '16px'};
  color: inherit;
`;

export const NavLabel = styled.span`
  font-size: 14px;
  color: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const NavDivider = styled.div`
  height: 1px;
  background-color: #f0f0f0;
  margin: 8px 16px;
`;

export const CollapseButton = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  background: #f5f5f5;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #666;

  &:hover {
    background: #e8e8e8;
    color: #333;
  }

  ${props => props.isMobile && `
    background: ${COLORS.$mainBlue};
    color: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    &:hover {
      background: ${COLORS.$mainBlue}dd;
    }
  `}
`;

export const MobileOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  
  @media (min-width: 769px) {
    display: none;
  }
`;

export const FooterSection = styled.div`
  padding: 16px 0 8px 0;
`;

export const LogoutButton = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #666;
  border-radius: 8px;

  &:hover {
    color: #ff4d4f;
    background-color: #fff2f0;
  }
`;

export const MainContentWrapper = styled.div`
  margin-left: ${props => props.sidebarCollapsed ? '64px' : '280px'};
  transition: margin-left 0.3s ease;
  min-height: 100vh;
  
  @media (max-width: 768px) {
    margin-left: 0;
  }
`;
